var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pledge-tx-wrapper __form_border" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletQuota.fromAddr")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input all unuse __ellipsis" }, [
          _vm._v(_vm._s(_vm.addr))
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "__form_input_title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("stakingAmount")) +
                "\n                "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.amountErr,
                    expression: "amountErr"
                  }
                ],
                staticClass: "err"
              },
              [_vm._v(_vm._s(_vm.amountErr))]
            )
          ]),
          _vm._v(" "),
          _c(
            "vite-input",
            {
              staticClass: "pledge-input-wrapper",
              attrs: {
                type: "number",
                valid: _vm.testAmount,
                placeholder: _vm.$t("walletQuota.amountPlaceholder", {
                  num: _vm.minNum
                })
              },
              model: {
                value: _vm.amount,
                callback: function($$v) {
                  _vm.amount = $$v
                },
                expression: "amount"
              }
            },
            [
              _c(
                "span",
                {
                  staticClass: "unit",
                  attrs: { slot: "after" },
                  slot: "after"
                },
                [_vm._v("dSLS")]
              )
            ]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "item" },
        [
          _c("div", { staticClass: "__form_input_title" }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("walletQuota.beneficialAddr")) +
                "\n                "
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isValidAddress,
                    expression: "!isValidAddress"
                  }
                ],
                staticClass: "err"
              },
              [_vm._v(_vm._s(_vm.$t("hint.addrFormat")))]
            )
          ]),
          _vm._v(" "),
          _c(
            "vite-input",
            {
              staticClass: "pledge-input-wrapper",
              attrs: {
                valid: _vm.testAddr,
                placeholder: _vm.$t("walletQuota.addrPlaceholder")
              },
              model: {
                value: _vm.toAddr,
                callback: function($$v) {
                  _vm.toAddr = $$v
                },
                expression: "toAddr"
              }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "click-outside",
                      rawName: "v-click-outside",
                      value: _vm.closeAddrList,
                      expression: "closeAddrList"
                    }
                  ],
                  staticClass: "add-unit __pointer",
                  attrs: { slot: "after" },
                  on: { click: _vm.toggleAddrList },
                  slot: "after"
                },
                [
                  _c("span", { staticClass: "add-icon" }),
                  _vm._v(" "),
                  _c(
                    "ul",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isShowAddrList,
                          expression: "isShowAddrList"
                        }
                      ],
                      staticClass: "list"
                    },
                    [
                      _c(
                        "li",
                        {
                          staticClass: "toaddr __pointer",
                          on: { click: _vm.addToAddrWithMine }
                        },
                        [_vm._v(_vm._s(_vm.$t("walletQuota.myAddr")))]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletQuota.time")))
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "__form_input unuse about" }, [
          _vm._v(_vm._s(_vm.$t("walletQuota.aboutDays", { day: "3" })))
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.btnUnuse,
                expression: "!btnUnuse"
              }
            ],
            staticClass: "__form_btn __pointer",
            on: { click: _vm.validTx }
          },
          [_vm._v(_vm._s(_vm.$t("submitStaking")))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.btnUnuse,
                expression: "btnUnuse"
              }
            ],
            staticClass: "__form_btn __pointer unuse"
          },
          [_vm._v(_vm._s(_vm.$t("submitStaking")))]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }